import InviteVM from './invite-vm';

export default {
  init() {
    ko.applyBindingsWithValidation(
      new InviteVM(),
      document.getElementById('invite_instructor'),
      {
        insertMessages: false,
        errorsAsTitle: true,
        decorateInputElement: true,
        parseInputAttributes: true,
        messagesOnModified: true,
        errorElementClass: 'error',
        errorMessageClass: 'error',
        decorateElementOnModified: true,
        decorateElement: true,

        grouping: {
          deep: true,
          observable: true,
          live: true
        }
      }
    );
  }
};
